function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  width: 40,
  height: 40,
  rx: 16,
  fill: "#EEF5D6"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M29.4705 11.3093C29.2113 10.5444 28.4854 10 27.6298 10H13.3705C12.515 10 11.802 10.5444 11.5298 11.3093L8.8335 19.0741V29.4444C8.8335 30.1574 9.41683 30.7407 10.1298 30.7407H11.4261C12.1391 30.7407 12.7224 30.1574 12.7224 29.4444V28.1481H28.2779V29.4444C28.2779 30.1574 28.8613 30.7407 29.5742 30.7407H30.8705C31.5835 30.7407 32.1668 30.1574 32.1668 29.4444V19.0741L29.4705 11.3093ZM13.8243 12.5926H27.1632L28.5632 16.6241H12.4243L13.8243 12.5926ZM11.4261 25.5556H29.5742V19.0741H11.4261V25.5556ZM14.6668 20.3704C13.5929 20.3704 12.7224 21.2409 12.7224 22.3148C12.7224 23.3887 13.5929 24.2593 14.6668 24.2593C15.7407 24.2593 16.6113 23.3887 16.6113 22.3148C16.6113 21.2409 15.7407 20.3704 14.6668 20.3704ZM24.3891 22.3148C24.3891 21.2409 25.2596 20.3704 26.3335 20.3704C27.4074 20.3704 28.2779 21.2409 28.2779 22.3148C28.2779 23.3887 27.4074 24.2593 26.3335 24.2593C25.2596 24.2593 24.3891 23.3887 24.3891 22.3148Z",
  fill: "#121221"
});

function SvgAutomotive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomotive);
export default __webpack_public_path__ + "static/media/Automotive.957ddb17.svg";
export { ForwardRef as ReactComponent };